import * as React from 'react';
import { observable } from 'mobx';
import { SessionReservationPaneState } from './states/SessionReservationPaneState';
import { observer } from 'mobx-react';
import { ReservationPane, ReservationSubPanes } from '../../atoms/reservations/ReservationPane';
import { ReservationPaneHeader } from '../../atoms/reservations/ReservationPaneHeader';
import { ReservationSummaryPane } from '../../molecules/reservations/ReservationSummaryPane';
import { ReservationActionPane } from '../../molecules/reservations/ReservationActionPane';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { ReservationCompletePane } from '../../molecules/reservations/ReservationCompletePane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { SessionReservationCompletePaneState } from './states/SessionReservationCompletePaneState';

type Props = {
    match: {
        url: string;
        params: {
            sessionId: string;
        };
    };
};

@observer
export class SessionReservationCompletePane extends React.Component<Props> {
    @observable paneState = new SessionReservationCompletePaneState();
    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.match.params.sessionId !== prevProps.match.params.sessionId) {
            this.init();
        }
    }

    init() {
        this.paneState.init(Number(this.props.match.params.sessionId));
    }

    render() {
        const { session: sessionResource } = this.paneState;
        if (sessionResource.loading) {
            return <GlobalLoader />;
        }
        if (sessionResource.isNotFound()) {
            return <NotFoundPage />;
        }
        const session = sessionResource.get();
        return (
            <ReservationCompletePane
                onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.home())}
                reservable={session}
            />
        );
    }
}
